import { render, staticRenderFns } from "./EditRoomModal.vue?vue&type=template&id=0f51fb3e&scoped=true"
import script from "./EditRoomModal.vue?vue&type=script&lang=js"
export * from "./EditRoomModal.vue?vue&type=script&lang=js"
import style0 from "./EditRoomModal.vue?vue&type=style&index=0&id=0f51fb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51fb3e",
  null
  
)

export default component.exports